import script from "./Crossover.vue?vue&type=script&lang=js"
export * from "./Crossover.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__